import { AfterViewInit, Component, ElementRef, inject, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeroComponent } from '../../components/hero/hero.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterLink, HeroComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements AfterViewInit, OnDestroy {
  private readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  private titleObserver?: IntersectionObserver;

  ngAfterViewInit(): void {
    if (typeof IntersectionObserver === 'undefined') {
      this.revealAllTitles();
      return;
    }

    const titles = this.elementRef.nativeElement.querySelectorAll<HTMLElement>('.js-title-reveal');

    this.titleObserver = new IntersectionObserver((entries, observer) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) {
          continue;
        }

        (entry.target as HTMLElement).classList.add('section-heading__title--animated');
        observer.unobserve(entry.target);
      }
    }, {
      threshold: 0.25
    });

    titles.forEach((title) => this.titleObserver?.observe(title));
  }

  ngOnDestroy(): void {
    this.titleObserver?.disconnect();
    this.titleObserver = undefined;
  }

  private revealAllTitles(): void {
    const titles = this.elementRef.nativeElement.querySelectorAll<HTMLElement>('.js-title-reveal');

    for (const title of titles) {
      title.classList.add('section-heading__title--animated');
    }
  }
}
